export default __webpack_public_path__ + "static/media/godot.b038bd38.png";